import { Checkbox, PasswordInput, Stack, TextInput } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";

export type UserFormType = {
  user_attributes: {
    email: string | undefined;
    password: string;
    active: boolean | undefined;
  };
};

type UserFormProps<T extends UserFormType> = {
  form: UseFormReturnType<T>;
  errors?: UserFormErrorTypes;
};

export type UserFormErrorTypes = {
  "user.email"?: string[];
  "user.password"?: string[];
};

export function UserForm<T extends UserFormType>({ form, errors }: UserFormProps<T>) {
  return (
    <Stack>
      <TextInput
        type="email"
        label="E-Mail"
        withAsterisk
        key={form.key("user_attributes.email")}
        {...form.getInputProps("user_attributes.email")}
        error={errors?.["user.email"]}
      />
      <PasswordInput
        label="Passwort"
        key={form.key("user_attributes.password")}
        {...form.getInputProps("user_attributes.password")}
        error={errors?.["user.password"]}
      />
      <Checkbox
        label="Aktiv"
        key={form.key("user_attributes.active")}
        {...form.getInputProps("user_attributes.active", { type: "checkbox" })}
      />
    </Stack>
  );
}
